<template>
  <div>
    <div class="swiper-container horarios">
      <div class="swiper-wrapper">
        <div class="swiper-slide text-center" v-for="(h, index) in empresa.entregas" :key="index" v-if="index < minimoHorario">
          <a href="javascript:" class="link-horario" @click="changeHorario(h)">
            <div class="card card-horario justify-content-center" :class="{'active': h.id_entrega === dados.id_entrega}" aria-hidden="true">
              <div class="bg-primary small mb-2" v-show="h.id_entrega === dados.id_entrega">Selecionado</div>
              <div class="font-weight-bold mb-1 small">Agendar - hoje</div>
              <div>{{h.horario_inicio}} - {{h.horario_fim}}</div>
            </div>
          </a>
        </div>
        <div class="swiper-slide text-center" v-if="empresa.entregas.length > 4 || !minimoHorario">
          <a href="javascript:" class="link-horario" @click="openModal()">
            <div class="card card-horario justify-content-center text-primary" aria-hidden="true">
              <div v-if="empresa.aberto === '1' && agendamento">
                <i class="fa fa-edit"></i>
                <div class="font-weight-bold small">{{agendamento.horario_inicio}} - {{agendamento.horario_fim}}</div>
              </div>
              <div v-else>
                <div class="mb-1"><i class="fa fa-plus"></i></div>
                <div class="font-weight-bold small">Ver Horários</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div id="modalAgendamento" class="modal-agendamento" v-show="opened">
      <div class="modal-agendamento-content">
        <div class="py-4 py-md-3 bg-white shadow-sm">
          <div class="container text-center position-relative">
            <a href="javascript:" @click="closeModal" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px; border-radius: 50%" aria-label="Voltar">
              <i class="fa fa-chevron-left text-dark"></i>
            </a>
            <h1 class="h6 font-weight-bold m-auto">Agendar pedido</h1>
          </div>
        </div>
        <div class="container mt-3 mb-4">
          <div v-if="empresa.aberto === '1'">
            <h6 class="ml-1">Sem agendamento</h6>
            <div class="row no-gutters">
              <div class="col-md-6 p-1">
                <a href="javascript:" class="text-dark text-decoration-none" @click="changeHorario(null)">
                  <div class="card card-horario mb-2" :class="{'active': !dados.id_entrega}" aria-hidden="true">
                    <div class="card-body d-flex align-items-center">
                      <div>
                        <div class="small text-primary">Sem agendamento</div>
                        <b>Pedir agora</b>
                      </div>
                      <div class="text-right" style="margin-left: auto" v-if="!dados.id_entrega">
                        <i class="fa fa-check text-primary"></i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <hr>
          </div>
          <h6 class="ml-1">Quando quer receber?</h6>
          <div class="row no-gutters">
            <div class="col-md-6 p-1" v-for="(h, index) in empresa.entregas" :key="index">
              <a href="javascript:" class="text-dark text-decoration-none" @click="changeHorario(h)">
                <div class="card card-horario mb-2" :class="{'active': h.id_entrega === dados.id_entrega}" aria-hidden="true">
                  <div class="card-body d-flex align-items-center">
                    <div>
                      <div class="small text-primary">Agendar - hoje</div>
                      <b>{{h.horario_inicio}} - {{h.horario_fim}}</b>
                    </div>
                    <div class="text-right" style="margin-left: auto" v-if="dados.id_entrega === h.id_entrega">
                      <i class="fa fa-check text-primary"></i>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.css'

  export default {
    name: "ModalAgendamento",
    props: ['empresa', 'dados', 'agendamento'],
    data () {
      return {
        opened: false,
        finalizar: false,
        swiper: '',
        minimoHorario: 4
      }
    },

    methods: {
      openModal() {
        document.body.classList.add("modal-open");
        this.opened = true;
      },

      closeModal() {
        this.finalizar = false;
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      changeHorario(h) {
        this.$emit('changeHorario', h, this.finalizar);
        this.closeModal();
      },
    },

    mounted() {
      this.minimoHorario = this.empresa.aberto === '1' ? 0 : 4;
      this.$nextTick(() => {
        this.swiper = new Swiper('.horarios', {
          slidesPerView: 'auto',
        });
      })
    },

    created() {
      this.$parent.$on('openModalHorario', (finalizar) => {
        this.finalizar = !!finalizar;
        this.openModal();
      });
    }
  }
</script>

<style scoped>
  .swiper-container {
    width: 100%;
  }

  .swiper-slide {
    width: auto;
  }

  .link-horario {
    text-decoration: none;
    color: unset;
    margin: 2px 8px 8px 2px;
    display: block;
    width: 150px;
  }

  .card-horario {
    height: 85px;
  }

  .modal-agendamento {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-agendamento-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 500px;
    height: 75vh;
    position: relative;
    border-radius: 12px;
  }

  .card-agendamento .card-body {
    min-height: 75px;
  }

  @media (max-width: 600px) {
    .modal-agendamento-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
    }
  }

  .card-horario.active {
    justify-content: normal!important;
    color: var(--lecard-primary);
    border: 2px solid var(--lecard-primary);
  }
</style>
